// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tLse","label":"styles_label__3HzjX"};